// extracted by mini-css-extract-plugin
export default {"Content":"WithSuspenseLoader_Content__Q4A7B"};